import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import AdvisorShell from '../components/advisor/AdvisorShell'
import { getCourse } from '../knowledge'

export default function AdvisorPage() {
  const [searchParams] = useSearchParams()
  const courseCode = searchParams.get('course') || searchParams.get('c') || null
  const targetCourse = courseCode ? getCourse(courseCode) : null

  const pageTitle = targetCourse
    ? `Consultation: ${targetCourse.title} | Admissions Advisor | Synergy Multimedia Academy`
    : 'Admissions Advisor | Synergy Multimedia Academy'

  const pageDescription = targetCourse
    ? `Ask questions about ${targetCourse.title} (${targetCourse.code}) — syllabus, tuition fees, installment plans, schedules, and career outcomes with an SMA Admissions Advisor.`
    : 'Talk to an SMA Admissions Advisor. Get personal guidance on courses, fees, intakes, and how Synergy Multimedia Academy works.'

  useEffect(() => {
    document.title = pageTitle
  }, [pageTitle])

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content={pageDescription}
        />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://synergymultimediaacademy.com/advisor" />
        <meta property="og:title" content={pageTitle} />
        <meta
          property="og:description"
          content={pageDescription}
        />
        <meta property="og:url" content="https://synergymultimediaacademy.com/advisor" />
      </Helmet>
      <AdvisorShell />
    </>
  )
}
